import { useContext, useLayoutEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { resetMyOrganisations } from 'granite-admin/utils/auth-singleton';
import useThemeConfigs from 'granite-admin/utils/useThemeConfigs';
import { getCookie, setCookie } from 'granite-admin/utils/storage';
import { ConfigContext } from './ConfigProvider';
const BackToBoard = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const config = useContext(ConfigContext);
  const {
    getSavedThemeConfigs,
    defaultThemeConfigs
  } = useThemeConfigs();
  useLayoutEffect(() => {
    if (config.subdomainRedirectEnabled && getCookie('redirectDomain') === 'yes') {
      const URL = `${getCookie('BAorigin')}/login`;
      const host = window.location.host;
      const domain = host.substring(host.indexOf('.') + 1, host.length - (window.location.port.length + (window.location.port.length ? 1 : 0)));
      setCookie('organisationData', '', 1, domain);
      setCookie('BAorigin', '', 1, domain);
      setCookie('redirectDomain', '', 1, domain);
      window.location = URL;
    } else {
      dispatch({
        type: 'organisations/UPDATE_SELECTED_ORGANISATION',
        data: {}
      });
      dispatch({
        type: 'organisations/UPDATE_ORGANISATIONS',
        data: null
      });
      dispatch({
        type: 'accounts/sidebar/RESET_SIDEBAR',
        data: []
      });
      resetMyOrganisations();
      dispatch({
        type: 'accounts/workspace/RESET_WORKSPACE'
      });
      dispatch({
        type: 'common/themeConfigs/UPDATE_THEME_CONFIGS',
        data: defaultThemeConfigs
      });
      getSavedThemeConfigs();
      history.replace('/dashboard');
    }
  }, [dispatch, history, getSavedThemeConfigs, defaultThemeConfigs, config.subdomainRedirectEnabled]);
  return null;
};
export default BackToBoard;